import React from 'react'
import dayjs from 'dayjs'
import 'dayjs/locale/nb'

import News, { type NewsProps, type NewsArticle } from '../../../react4xp/components/News'

const formatDate = (value?: string) => {
  if (!value) {
    return value
  }

  const parsedDate = dayjs(value)
  if (!parsedDate.isValid()) {
    return value
  }

  return parsedDate.locale('nb').format('DD. MMM YYYY')
}

const withFormattedDates = (articles?: NewsArticle[]) =>
  Array.isArray(articles)
    ? articles.map((article) => ({
        ...article,
        date: formatDate(article.date)
      }))
    : articles

function NewsPart ({ articles, ...props }: NewsProps) {
  return (
    <News
      articles={withFormattedDates(articles)}
      {...props}
    />
  )
}

export default (props: NewsProps) => <NewsPart {...props} />
